import styled from 'styled-components';

import TimeIcon from '../../../assets/icons/secondary/Time Circle.svg';
import {getColor, gts, square} from '../../../styles';
import {View} from '../../../uikit/View';

export const Container = styled(View)`
  align-items: baseline;
  gap: ${gts('gap.sm')};
`;

export const DurationIcon = styled(TimeIcon).attrs(p => ({
  fill: getColor('icon3')(p),
}))`
  align-self: center;
  ${square(16)};
`;
